export default function containsMultipleEmails(email) {
  return email.split("@").length > 2;
}
